/**
 * Live feedback, computed from the numbers and the mine count alone (CLAUDE.md §10): the
 * answer key never reaches this code. Only what can no longer be right is flagged.
 */
import type { Feedback } from "../types";
import { resizeRows } from "./progress";
import { contradictions } from "./rules";
import { cellId, type MinesweeperDefinition, type MinesweeperProgress } from "./types";

export function localFeedback(
  definition: MinesweeperDefinition,
  progress: MinesweeperProgress,
): Feedback[] {
  const marks = resizeRows(progress.rows, definition.rows, definition.cols);
  const found = contradictions(definition.cells, definition.mines, marks);
  const feedback: Feedback[] = [];
  if (found.numbers.size > 0)
    feedback.push({
      type: "number",
      code: "number_contradiction",
      cells: [...found.numbers].map((k) => {
        const [r, c] = k.split(",").map(Number);
        return cellId(r, c);
      }),
    });
  if (found.total) feedback.push({ type: "total", code: "mine_total_contradiction", cells: [] });
  return feedback;
}
